var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCancelLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-872.000000, -696.000000)",
    fill: "#BABABA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M881.320816,705.320816 C881.100282,705.54135 880.753266,705.558314 880.513274,705.371709 L880.45564,705.320816 L877.000191,701.864446 L873.54436,705.320816 C873.305448,705.559728 872.918096,705.559728 872.679184,705.320816 C872.45865,705.100282 872.441686,704.753266 872.628291,704.513274 L872.679184,704.45564 L876.135554,700.999809 L872.679184,697.54436 C872.440272,697.305448 872.440272,696.918096 872.679184,696.679184 C872.899718,696.45865 873.246734,696.441686 873.486726,696.628291 L873.54436,696.679184 L877.000191,700.134492 L880.45564,696.679184 C880.694552,696.440272 881.081904,696.440272 881.320816,696.679184 C881.54135,696.899718 881.558314,697.246734 881.371709,697.486726 L881.320816,697.54436 L877.865508,700.999809 L881.320816,704.45564 C881.559728,704.694552 881.559728,705.081904 881.320816,705.320816 Z",
    id: "Path"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelLogo);
export default __webpack_public_path__ + "static/media/cancel_logo.64521cab.svg";
export { ForwardRef as ReactComponent };